import { Component, OnInit, ViewChild, forwardRef } from '@angular/core';
import { 
    
} from '@ionic/angular/standalone';

import { DataService } from '@app/services';
import { StoriesPlayerComponent } from '@app/components';
import { OperationStory } from '@app/models';

@Component({
    selector: 'app-stories-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    imports: [
        forwardRef(() => StoriesPlayerComponent)
    ]
})
export class StoriesListComponent  implements OnInit {
    
    @ViewChild('storiesPlayer') storiesPlayer: StoriesPlayerComponent;
    
    stories: Array<OperationStory> = [];
    
    constructor(      
        public dataService: DataService
    ) { }

    ngOnInit() {
       this.stories = this.dataService.operation.getStoriesSorted(this.dataService.ambassador);
    }
    
    openStory(storyID: string){
        this.storiesPlayer.openStory(storyID);
    }
}
